'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _LocationForm = require('../ui/LocationForm');

var _LocationForm2 = _interopRequireDefault(_LocationForm);

var _LogentryModel = require('../../logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _LocationModel = require('../model/LocationModel');

var _LocationModel2 = _interopRequireDefault(_LocationModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditLocation = function EditLocation(element, args) {
  var _this = this;

  _classCallCheck(this, EditLocation);

  this.onchange = function () {
    _this.data = _this.locationForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('locations', _this.data.getJSON()).then(function (location) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && location.id) {
        window.PRIM.navigate('/locations/' + location.id, true);
      }

      if (location) {
        _this.data.values.id = location.id;
        _this.locationForm.setValue(_this.data);
      }
    });
  };

  if (args) {
    if (args.id) {
      window.PRIM.dataAccess.resolve('locations', args.id, true).then(function (location) {
        _this.data = location;
        _this.locationForm.setValue(_this.data);

        window.PRIM.dataAccess.resolve('positions', _this.data.values.id, true, 'location_id').then(function (positions) {
          _this.data.positions = positions;
          _this.positionIndex.setItems(_this.data.positions);
        }, function () {}).catch(function () {});

        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
          var results = logentries.filter(function (logentry) {
            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.location;
          });

          _this.data.logentries = results.map(function (logentry) {
            return new _LogentryModel2.default(logentry);
          });

          _this.logIndex.setItems(_this.data.logentries);
          _this.locationForm.setValue(_this.data);
        }, function () {
          _this.locationForm.setValue(_this.data);
        }).catch(function () {});
      }, function () {
        if (confirm('Deze vestiging bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe vestiging aanmaken?')) {
          window.PRIM.navigate('/locations/');
        } else {
          history.back();
        }
      }).catch(function () {});
    } else if (args.organisation_id) {
      window.PRIM.dataAccess.resolve('organisations', args.organisation_id, true).then(function (organisation) {
        _this.data = new _LocationModel2.default();
        _this.data.values.organisation_id = organisation.values.id;
        _this.data.organisation = organisation;
        _this.locationForm.setValue(_this.data);
      });
    }
  }

  this.data = new _LocationModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Vestiging bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/positions/location/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze afdeling.');
        }
      },
      icon: '\uE034',
      label: 'Functie'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/logentries/location/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze vestiging.');
        }
      },
      icon: '\uE032',
      label: 'Logboekregel'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze vestiging wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('locations', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze vestiging.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  var primaryData = document.createElement('section');
  primaryData.className = 'primary';
  var secondaryData = document.createElement('section');
  secondaryData.className = 'secondary';

  this.locationForm = new _LocationForm2.default(primaryData, { location: this.data, onchange: this.onchange });

  var fieldsetPositions = document.createElement('fieldset');
  var legendPositions = document.createElement('legend');
  legendPositions.innerHTML = 'Functies';
  fieldsetPositions.appendChild(legendPositions);

  var onclickPositions = function onclickPositions(item) {
    window.PRIM.navigate('/positions/' + item.values.id);
  };

  this.positionIndex = new _IndexControl2.default(fieldsetPositions, { items: this.data.positions, onclick: onclickPositions });

  secondaryData.appendChild(fieldsetPositions);

  var fieldsetLog = document.createElement('fieldset');
  var legendLog = document.createElement('legend');
  legendLog.innerHTML = 'Logboek';
  fieldsetLog.appendChild(legendLog);

  var onclickLogentry = function onclickLogentry(item) {
    window.PRIM.navigate('/logentries/' + item.values.id);
  };

  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });

  secondaryData.appendChild(fieldsetLog);

  divContent.appendChild(primaryData);
  divContent.appendChild(secondaryData);
  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditLocation;


//////////////////
// WEBPACK FOOTER
// ./js/modules/location/action/EditLocation.js
// module id = 62
// module chunks = 0